import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext.jsx';
import { LINKS } from '../constants.js';
import { Sym, WaifuTile } from './ui.jsx';
import { DownloadButtons } from './DownloadButtons.jsx';

export const Hero = () => {
  const { t } = useLanguage();
  const chars = t.waifus.characters;
  const [idx, setIdx] = useState(0);
  const [manual, setManual] = useState(false);

  useEffect(() => {
    if (manual) return undefined;
    const id = setInterval(() => setIdx((i) => (i + 1) % chars.length), 3000);
    return () => clearInterval(id);
  }, [manual, chars.length]);

  const w = chars[idx];
  const locked = !!w.isLocked;
  const initial = locked ? '?' : w.name.charAt(0);

  return (
    <section className="hero">
      <div className="hero-sweep" />
      <div className="hero-grid">
        <div className="hero-left">
          <div className="badge eyebrow"><Sym name="castle" size={14} />{t.hero.badge.replace('✨', '').trim()}</div>
          <img className="hero-logo" src={LINKS.logo} alt="Waifu Briscola" fetchPriority="high" width="560" height="280" />
          <h1 className="sr-only">{t.hero.title} - {t.hero.tagline}</h1>
          <p className="hand hero-tagline">{t.hero.tagline}</p>
          <DownloadButtons event="hero_download_click" section="hero" />
        </div>

        <div className="hero-right">
          <div className="stage">
            <div className="card-back">
              <div className="ring" />
              <div className="corner tl">A</div>
              <div className="corner br">A</div>
            </div>
            <div className="card-front">
              <div className="art" key={w.id}>
                <img src={w.imageUrl} alt={locked ? 'Locked character' : w.name + ' - ' + w.role} className={locked ? 'locked-img' : ''} width="260" height="390" />
                {locked && <div className="lock-overlay"><div className="lock-circle"><Sym name="lock" size={28} /></div></div>}
              </div>
              <div className="foot">
                <div className="name">{locked ? '????' : w.name}</div>
                <div className="bar" style={{ background: 'linear-gradient(90deg, transparent, ' + w.theme + ', transparent)' }} />
                <div className="hand role">{w.role}</div>
              </div>
              <div className="corner tl">{initial}</div>
              <div className="corner br">{initial}</div>
            </div>
            <div className="particle gold" />
            <div className="particle cyan" />
          </div>
          <div className="roster">
            {chars.map((c, i) => (
              <WaifuTile key={c.id} waifu={{ ...c, name: c.isLocked ? '???' : c.name }} selected={i === idx} isSafeMode={!!c.isLocked} onClick={() => { setIdx(i); setManual(true); }} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

